import { SERVICE_CODES } from '@/lib/consts';

export const SERVICE_CODE = SERVICE_CODES.EXTENDED_CRIMINAL_RECORD_EXTRACT;
export const STEP_NUMBER_TO_PAY = 8;
export const STEP_NUMBER_SIGN_UP = 7;

export enum ExtractFormType {
  ELECTRONIC = 'ELECTRONIC',
  PAPER = 'PAPER',
  UNSET = 'UNSET',
}

export const ExtractFormTypeLabelMapping: Partial<Record<ExtractFormType, string>> = {
  [ExtractFormType.ELECTRONIC]: 'Хочу отримати тільки електронну форму витягу',
  [ExtractFormType.PAPER]: 'Хочу отримати паперову форму витягу',
};

export enum ExtractType {
  FULL = 'F',
  SHORT = 'S',
}

export const ExtractTypeMapping = {
  [ExtractType.FULL]: 'Повний',
  [ExtractType.SHORT]: 'Скорочений',
};

export const ExtractTypeSelectOptions = {
  [ExtractType.FULL]: {
    id: ExtractType.FULL,
    label: ExtractTypeMapping[ExtractType.FULL],
  },
  [ExtractType.SHORT]: {
    id: ExtractType.SHORT,
    label: ExtractTypeMapping[ExtractType.SHORT],
  },
};
